import {
  Breakpoint,
  useDeviceSize,
} from '@grubhubprod/umami-library/dist/hooks/useDeviceSize';
import { getWindow } from 'src/utilities/window';

export interface IScreenSizesFlags {
  isTablet: boolean;
  isPhone: boolean;
  isDesktop: boolean;
}

export function isPhoneView(): boolean {
  const window = getWindow();
  const { breakpoint } = useDeviceSize(window);
  return breakpoint < Breakpoint.sm;
}

export function useScreenSizes(): IScreenSizesFlags {
  const window = getWindow();
  const { breakpoint } = useDeviceSize(window);
  const isPhone = breakpoint < Breakpoint.sm;
  const isTablet = breakpoint > Breakpoint.sm && breakpoint < Breakpoint.lg;
  const isDesktop = breakpoint >= Breakpoint.lg;
  return { isPhone, isTablet, isDesktop };
}
